import { BaseResponseInterface } from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  store: 'website/market/apps/' // 商城
};

//----- 获取权限 Start -----//
export interface RequestStoreGetPermission {
}

export interface ResponseStoreGetPermission extends BaseResponseInterface {
}

export async function AxiosStoreGetPermission(params: RequestStoreGetPermission): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.store }permission`,
    params
  });
}

//----- 获取权限 End -----//